
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BillingManagedByGithub',
  props: {
    login: {
      type: String,
      required: true
    }
  }
})
